export const MERGE_MODE = {
  replace: 'replace',
  complete: 'complete',
};

const normalizeCode = (value) => (value === undefined || value === null ? '' : String(value).trim());

/**
 * % Indicadores DRE.
 * @param {Record<number, string[]>} currentByType seleção atual por IndicatorType
 * @param {Array<{ type: number, dreIds: string[] }>} indicators sugestão da IA
 * @param {'replace'|'complete'} mode replace = resultado é exatamente a sugestão; complete = só preenche tipos vazios
 * @returns {Record<number, string[]>}
 */
export const mergeDreSelections = (currentByType, indicators, mode) => {
  const suggested = {};
  (indicators || []).forEach((item) => {
    suggested[item.type] = item.dreIds || [];
  });

  if (mode === MERGE_MODE.replace) return suggested;

  const result = { ...currentByType };
  Object.entries(suggested).forEach(([type, ids]) => {
    if (!Array.isArray(result[type]) || result[type].length === 0) result[type] = ids;
  });
  return result;
};

/**
 * Indicadores KPI / Grupos Financeiros (linhas do DragDropConfigurator).
 * @param {Array<Record<string, unknown>>} currentRows configuração atual
 * @param {Array<{ codCategoria: string, type: number }>} assignments sugestão da IA
 * @param {'replace'|'complete'} mode replace = resultado é exatamente a sugestão; complete = só adiciona categorias ainda sem vínculo
 * @param {'type'|'financialGroup'} typeField campo do tipo na linha, conforme o parameterType
 */
export const mergeCategoryAssignments = (currentRows, assignments, mode, typeField) => {
  const rows = Array.isArray(currentRows) ? currentRows : [];
  const toRow = (item) => ({ codCategoria: normalizeCode(item.codCategoria), [typeField]: item.type });

  if (mode === MERGE_MODE.replace) {
    // Reaproveita o Id da linha existente quando categoria+tipo não mudam (evita soft-delete/insert à toa).
    const idByKey = new Map();
    rows.forEach((row) => {
      const code = normalizeCode(row.codCategoria ?? row.CodCategoria);
      const type = row[typeField] ?? row.type ?? row.Type ?? row.financialGroup ?? row.FinancialGroup;
      const id = row.Id ?? row.id;
      if (code && id) idByKey.set(`${Number(type)}|${code}`, id);
    });
    return (assignments || []).map((item) => {
      const row = toRow(item);
      const id = idByKey.get(`${Number(item.type)}|${row.codCategoria}`);
      return id ? { ...row, Id: id } : row;
    });
  }

  const linked = new Set(rows.map((row) => normalizeCode(row.codCategoria ?? row.CodCategoria)));
  const additions = (assignments || [])
    .filter((item) => !linked.has(normalizeCode(item.codCategoria)))
    .map(toRow);
  return [...rows, ...additions];
};
